import _noop from 'lodash/noop';
import React from 'react';
import { resetBugsnagReporters, setBugsnagReporters } from './registry';
import {
  BugsnagReporting,
  ReportErrorToBugsnag,
  ReportInfoToBugsnag,
} from './types';

export const BugsnagReportingContext = React.createContext<BugsnagReporting>({
  reportErrorToBugsnag: _noop,
  reportInfoToBugsnag: _noop,
});

/**
 * To enable the toolkit to report errors to Bugsnag, wrap the application in this provider.
 *
 * If not wrapped, any component attempting to message bugsnag will just no-op
 */
export const BugsnagReportingProvider: React.FC<{
  children: any;
  reportErrorToBugsnag: ReportErrorToBugsnag;
  reportInfoToBugsnag: ReportInfoToBugsnag;
}> = ({ children, reportErrorToBugsnag, reportInfoToBugsnag }) => {
  const bugsnagReporting = React.useMemo<BugsnagReporting>(
    () => ({ reportErrorToBugsnag, reportInfoToBugsnag }),
    [reportErrorToBugsnag, reportInfoToBugsnag],
  );

  // Sync direct (non-hook) reporters with provider so utilities outside React can report
  // via reportErrorToBugsnagDirect/reportInfoToBugsnagDirect. Defaults are no-op until mounted.
  React.useEffect(() => {
    setBugsnagReporters(reportErrorToBugsnag, reportInfoToBugsnag);
    return () => resetBugsnagReporters();
  }, [reportErrorToBugsnag, reportInfoToBugsnag]);

  return (
    <BugsnagReportingContext.Provider value={bugsnagReporting}>
      {children}
    </BugsnagReportingContext.Provider>
  );
};
